import { PlatformEnum } from 'src/shared/enums';

export enum DeviceEnum {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

export enum ConsumableContentTypeEnum {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}

export enum ApectRatioEnum {
  '1_1' = '1:1',
  '4_3' = '4:3',
  '5_4' = '5_4',
  '16_9' = '16:9',
  '3_4' = '3:4',
  '4_5' = '4:5',
  '9_16' = '9:16',
}

type LandingBlocks = {
  [key: string]: {
    title: string;
    availableDevices: DeviceEnum[];
    blocks: Blocks[];
  };
};

type BlockVideoContent = {
  blockType: 'VideoContent';
  props: VideoContentProps;
};

type BlockImageContent = {
  blockType: 'ImageContent';
  props: ImageContentProps;
};

type BlockConsumableContent = {
  blockType: 'ConsumableContent';
  props: ConsumableContentProps;
};

type BlockBenefitsContent = {
  blockType: 'BenefitsContent';
  props: BenefitsContentProps;
};

export type Blocks =
  | BlockVideoContent
  | BlockImageContent
  | BlockConsumableContent
  | BlockBenefitsContent;

export type VideoContentProps = {
  title: string;
  description: string;
  video: {
    mobile: Video;
    tablet: Video;
    desktop: Video;
  };
};

type Video = {
  vertical: boolean;
  url: string;
  poster?: string;
  aspectRatio?: ApectRatioEnum;
};

export type ImageContentProps = {
  title: string;
  description: string;
  image: Image;
};

type Image = {
  mobile: string;
  tablet: string;
  desktop: string;
};

export interface BenefitsContentProps {
  image: Image;
  title: string;
  benefits: Benefit[];
}

export interface Benefit {
  icon: string;
  description: string;
}

type ConsumableContentDefaultProps = {
  type: ConsumableContentTypeEnum.DEFAULT;
  userName: string;
};

type ConsumableContentCustomProps = {
  type: ConsumableContentTypeEnum.CUSTOM;
  image: Image;
  title: string;
  description: string;
};

export type ConsumableContentProps =
  | ConsumableContentDefaultProps
  | ConsumableContentCustomProps;

export const customLandings = new Map<number, LandingBlocks>();

customLandings.set(4397, {
  [PlatformEnum.CON_ARGENTINA]: {
    title: 'Alcaraz landing',
    availableDevices: [DeviceEnum.MOBILE, DeviceEnum.TABLET],
    blocks: [
      {
        blockType: 'VideoContent',
        props: {
          title: 'Hola, isdinlover',
          description:
            'Te damos la bienvenida a LOVE ISDIN, la comunidad de los amantes de la piel donde podrás vivir <strong>experiencias exclusivas de tenis con nuestro embajador Carlos Alcaraz</strong>, y mucho más. ¡Accede a LOVE ISDIN y descubre cómo!',
          video: {
            mobile: {
              vertical: true,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/SH-2401+MAGIC+ALCARAZ+ASSET+7+9_16+ARRI_03+4-5+SUBS+ESP+375x468.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              aspectRatio: ApectRatioEnum['4_5'],
            },
            tablet: {
              vertical: false,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/SH-2401+MAGIC+ALCARAZ+ASSET+7+9_16+ARRI_03+4-5+SUBS+ESP+375x468.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              // vertical: false,
              // url: 'https://media.love.isdin.com/con-es/consumables/videos/Video_FWM+Alcaraz_horizontal.mp4',
            },
            desktop: {
              vertical: false,
              url: '',
            },
          },
        },
      },
      {
        blockType: 'ConsumableContent',
        props: {
          type: ConsumableContentTypeEnum.CUSTOM,
          title: '¿Quieres vivir momentos mágicos con Alcaraz?',
          description: 'Disfruta dentro y fuera de la pista con el número 1',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_LICON_Desk.jpg',
            desktop: '',
          },
        },
      },
      {
        blockType: 'ImageContent',
        props: {
          title: 'Fusion Water MAGIC by Alcaraz',
          description:
            'Te acabas de marcar un buen punto, porque <strong>fotoprotegerse</strong> es el primer paso para ganar. Con textura ultraligera y de rápida absorción, este extraordinario fotoprotector es <strong>resistente al sudor</strong> y se ha formulado con <strong>Heat Stress Protect</strong>, un potente antioxidante que ayuda a prevenir el daño oxidativo provocado por el calor. Feel the MAGIC of science on your skin!',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-image-mobile.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-image-tablet.png',
            desktop: '',
          },
        },
      },
      {
        blockType: 'BenefitsContent',
        props: {
          title: 'Ser isdinlover es disfrutar de beneficios únicos',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Desk.png',
            desktop: '',
          },
          benefits: [
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono01.png',
              description:
                'Disfruta de productos y experiencias <strong>únicas.</strong>',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono02.png',
              description:
                'Aprende a <strong>cuidar tu piel</strong> junto a los mejores expertos.',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono03.png',
              description:
                'Entérate de las últimas novedades <strong>¡antes que nadie!</strong>',
            },
          ],
        },
      },
    ],
  },
  [PlatformEnum.CON_PERU]: {
    title: 'Alcaraz landing',
    availableDevices: [DeviceEnum.MOBILE, DeviceEnum.TABLET],
    blocks: [
      {
        blockType: 'VideoContent',
        props: {
          title: 'Hola, isdinlover',
          description:
            'Te damos la bienvenida a LOVE ISDIN, la comunidad de los amantes de la piel donde podrás vivir <strong>experiencias exclusivas de tenis con nuestro embajador Carlos Alcaraz</strong>, y mucho más. ¡Accede a LOVE ISDIN y descubre cómo!',
          video: {
            mobile: {
              vertical: true,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/SH-2401+MAGIC+ALCARAZ+ASSET+7+9_16+ARRI_03+4-5+SUBS+ESP+375x468.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              aspectRatio: ApectRatioEnum['4_5'],
            },
            tablet: {
              vertical: false,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/SH-2401+MAGIC+ALCARAZ+ASSET+7+9_16+ARRI_03+4-5+SUBS+ESP+375x468.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
            },
            desktop: {
              vertical: false,
              url: '',
            },
          },
        },
      },
      {
        blockType: 'ConsumableContent',
        props: {
          type: ConsumableContentTypeEnum.CUSTOM,
          title: '¿Quieres vivir momentos mágicos con Alcaraz?',
          description: 'Disfruta dentro y fuera de la pista con el número 1',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_LICON_Desk.jpg',
            desktop: '',
          },
        },
      },
      {
        blockType: 'ImageContent',
        props: {
          title: 'Fusion Water MAGIC by Alcaraz',
          description:
            'Te acabas de marcar un buen punto, porque <strong>fotoprotegerse</strong> es el primer paso para ganar. Con textura ultraligera y de rápida absorción, este extraordinario fotoprotector es <strong>resistente al sudor</strong> y se ha formulado con <strong>Heat Stress Protect</strong>, un potente antioxidante que ayuda a prevenir el daño oxidativo provocado por el calor. Feel the MAGIC of science on your skin!',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-image-mobile.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-image-tablet.png',
            desktop: '',
          },
        },
      },
      {
        blockType: 'BenefitsContent',
        props: {
          title: 'Ser isdinlover es disfrutar de beneficios únicos',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Desk.png',
            desktop: '',
          },
          benefits: [
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono01.png',
              description:
                'Disfruta de productos y experiencias <strong>únicas.</strong>',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono02.png',
              description:
                'Aprende a <strong>cuidar tu piel</strong> junto a los mejores expertos.',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono03.png',
              description:
                'Entérate de las últimas novedades <strong>¡antes que nadie!</strong>',
            },
          ],
        },
      },
    ],
  },
  [PlatformEnum.CON_FRANCE]: {
    title: 'Alcaraz landing',
    availableDevices: [DeviceEnum.MOBILE, DeviceEnum.TABLET],
    blocks: [
      {
        blockType: 'VideoContent',
        props: {
          title: 'Bonjour isdinlover',
          description:
            'Bienvenue sur LOVE ISDIN, la communauté de celles et ceux qui aiment prendre soin de leur peau. Ici vous pourrez vivre des <strong>expériences exclusives de tennis avec notre ambassadeur Carlos Alcaraz</strong>, et bien plus encore. Rejoignez LOVE ISDIN et découvrez comment vivre tous ces moments!',
          video: {
            mobile: {
              vertical: true,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/SH-2401-MAGIC-ALCARAZ-ASSET-7-4_5_MIX-SUBS-FRA.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              aspectRatio: ApectRatioEnum['4_5'],
            },
            tablet: {
              vertical: false,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/SH-2401-MAGIC-ALCARAZ-ASSET-7-4_5_MIX-SUBS-FRA.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
            },
            desktop: {
              vertical: false,
              url: '',
            },
          },
        },
      },
      {
        blockType: 'ConsumableContent',
        props: {
          type: ConsumableContentTypeEnum.CUSTOM,
          title: 'Prêt à vivre des moments magiques avec Alcaraz ?',
          description:
            'Utilisez vos 300 points, continuez à scanner vos produits ISDIN favoris et accumulez ainsi encore plus de points! Vous profiterez ainsi de l’expérience sur le court et en dehors avec le numéro 1 mondial!',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_LICON_Desk.jpg',
            desktop: '',
          },
        },
      },
      {
        blockType: 'ImageContent',
        props: {
          title: 'Edition limitée Fusion Water MAGIC Carlos Alcaraz',
          description:
            'Félicitations! <strong>Bien se protéger du soleil</strong> est la première étape vers la victoire. Avec sa texture ultralégère et son absorption ultra rapide, cette crème solaire extraordinaire <strong>résiste à la transpiration</strong>. Formulée à partir du <strong>Heat Stress Protect</strong>, un puissant antioxydant qui aide à prévenir les dommages sur la peau causés par la chaleur. Appliquez Fusion Water Magic et ressentez toute la MAGIE de la science sur votre peau!',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-image-mobile.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-image-tablet.png',
            desktop: '',
          },
        },
      },
      {
        blockType: 'BenefitsContent',
        props: {
          title: "Être un isdinlover, c'est profiter d'avantages uniques",
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Desk.png',
            desktop: '',
          },
          benefits: [
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono01.png',
              description:
                'Découvrez nos produits et vivez des expériences uniques.',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono02.png',
              description:
                'Apprenez à prendre soin de votre peau à l’aide des meilleurs experts.',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono03.png',
              description:
                'Soyez informé(e) des dernières nouveautés avant tout le monde!',
            },
          ],
        },
      },
    ],
  },
  [PlatformEnum.CON_PORTUGAL]: {
    title: 'Alcaraz landing',
    availableDevices: [DeviceEnum.MOBILE, DeviceEnum.TABLET],
    blocks: [
      {
        blockType: 'VideoContent',
        props: {
          title: 'Olá, isdinlover',
          description:
            'Bem-vindo a LOVE ISDIN, a comunidade para todos aquele que cuidam da sua pele, aqui pode viver <strong>experiências exclusivas no mundo do ténis com o nosso embaixador Carlos Alcaraz</strong>, e muito mais. Junte-se a LOVE ISDIN e descubra como!',
          video: {
            mobile: {
              vertical: true,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/SH-2401-MAGIC-ALCARAZ-ASSET-7-4_5_MIX-SUBS-PT.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              aspectRatio: ApectRatioEnum['4_5'],
            },
            tablet: {
              vertical: false,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/SH-2401+MAGIC+ALCARAZ+ASSET+7+9_16_MIX+SUBS+PT.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
            },
            desktop: {
              vertical: false,
              url: '',
            },
          },
        },
      },
      {
        blockType: 'ConsumableContent',
        props: {
          type: ConsumableContentTypeEnum.CUSTOM,
          title: 'Quer viver momentos mágicos com o Alcaraz?',
          description:
            'Desfrutar dentro e fora do court com o jogador número 1',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_LICON_Desk.jpg',
            desktop: '',
          },
        },
      },
      {
        blockType: 'ImageContent',
        props: {
          title: 'Fusion Water MAGIC by Alcaraz',
          description:
            'Acabou de marcar um ponto, porque <strong>a fotoproteção</strong> é o primeiro passo para vencer. Com uma textura ultraligeira e de rápida absorção, este extraordinário fotoprotector é <strong>resistente ao suor</strong> e foi formulado com <strong>Heat Stress Protect</strong>, um potente antioxidante que ajuda a prevenir os danos oxidativos provocados pelo calor. Feel the MAGIC of science on your skin!',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-image-mobile.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-image-tablet.png',
            desktop: '',
          },
        },
      },
      {
        blockType: 'BenefitsContent',
        props: {
          title: 'Ser um isdinlover é desfrutar de benefícios únicos',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Desk.png',
            desktop: '',
          },
          benefits: [
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono01.png',
              description:
                'Desfrutar de produtos e experiências <strong>únicas.</strong>',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono02.png',
              description:
                'Aprenda a <strong>cuidar da sua pele</strong> com os melhores especialistas.',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono03.png',
              description:
                'Descubra as últimas novidades <strong>em primeira mão!</strong>',
            },
          ],
        },
      },
    ],
  },
});

customLandings.set(4924, {
  [PlatformEnum.CON_ARGENTINA]: {
    title: 'Alcaraz landing',
    availableDevices: [DeviceEnum.MOBILE, DeviceEnum.TABLET],
    blocks: [
      {
        blockType: 'VideoContent',
        props: {
          title: 'Hola, isdinlover',
          description:
            'Te damos la bienvenida a LOVE ISDIN, la comunidad de los amantes de la piel donde podrás vivir <strong>experiencias exclusivas de tenis con nuestro embajador Carlos Alcaraz</strong>, y mucho más. ¡Accede a LOVE ISDIN y descubre cómo!',
          video: {
            mobile: {
              vertical: true,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/VIDEO_LANDING_ROLAND_GARROS_2.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              aspectRatio: ApectRatioEnum['4_5'],
            },
            tablet: {
              vertical: false,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/VIDEO_LANDING_ROLAND_GARROS_2.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              // vertical: false,
              // url: 'https://media.love.isdin.com/con-es/consumables/videos/Video_FWM+Alcaraz_horizontal.mp4',
            },
            desktop: {
              vertical: false,
              url: '',
            },
          },
        },
      },
      {
        blockType: 'ConsumableContent',
        props: {
          type: ConsumableContentTypeEnum.CUSTOM,
          title: '¿Quieres vivir momentos mágicos con Alcaraz?',
          description: 'Disfruta dentro y fuera de la pista con el número 1',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-consumable-racket.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-consumable-racket.png',
            desktop: '',
          },
        },
      },
      {
        blockType: 'ImageContent',
        props: {
          title: 'Fusion Water MAGIC by Alcaraz',
          description:
            'Te acabas de marcar un buen punto, porque <strong>fotoprotegerse</strong> es el primer paso para ganar. Con textura ultraligera y de rápida absorción, este extraordinario fotoprotector es <strong>resistente al sudor</strong> y se ha formulado con <strong>Heat Stress Protect</strong>, un potente antioxidante que ayuda a prevenir el daño oxidativo provocado por el calor. Feel the MAGIC of science on your skin!',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-image.jpg',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-image.jpg',
            desktop: '',
          },
        },
      },
      {
        blockType: 'BenefitsContent',
        props: {
          title: 'Ser isdinlover es disfrutar de beneficios únicos',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Desk.png',
            desktop: '',
          },
          benefits: [
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono01.png',
              description:
                'Disfruta de productos y experiencias <strong>únicas.</strong>',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono02.png',
              description:
                'Aprende a <strong>cuidar tu piel</strong> junto a los mejores expertos.',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono03.png',
              description:
                'Entérate de las últimas novedades <strong>¡antes que nadie!</strong>',
            },
          ],
        },
      },
    ],
  },
  [PlatformEnum.CON_PERU]: {
    title: 'Alcaraz landing',
    availableDevices: [DeviceEnum.MOBILE, DeviceEnum.TABLET],
    blocks: [
      {
        blockType: 'VideoContent',
        props: {
          title: 'Hola, isdinlover',
          description:
            'Te damos la bienvenida a LOVE ISDIN, la comunidad de los amantes de la piel donde podrás vivir <strong>experiencias exclusivas de tenis con nuestro embajador Carlos Alcaraz</strong>, y mucho más. ¡Accede a LOVE ISDIN y descubre cómo!',
          video: {
            mobile: {
              vertical: true,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/VIDEO_LANDING_ROLAND_GARROS_2.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              aspectRatio: ApectRatioEnum['4_5'],
            },
            tablet: {
              vertical: false,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/VIDEO_LANDING_ROLAND_GARROS_2.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              // vertical: false,
              // url: 'https://media.love.isdin.com/con-es/consumables/videos/Video_FWM+Alcaraz_horizontal.mp4',
            },
            desktop: {
              vertical: false,
              url: '',
            },
          },
        },
      },
      {
        blockType: 'ConsumableContent',
        props: {
          type: ConsumableContentTypeEnum.CUSTOM,
          title: '¿Quieres vivir momentos mágicos con Alcaraz?',
          description: 'Disfruta dentro y fuera de la pista con el número 1',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-consumable-racket.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-consumable-racket.png',
            desktop: '',
          },
        },
      },
      {
        blockType: 'ImageContent',
        props: {
          title: 'Fusion Water MAGIC by Alcaraz',
          description:
            'Te acabas de marcar un buen punto, porque <strong>fotoprotegerse</strong> es el primer paso para ganar. Con textura ultraligera y de rápida absorción, este extraordinario fotoprotector es <strong>resistente al sudor</strong> y se ha formulado con <strong>Heat Stress Protect</strong>, un potente antioxidante que ayuda a prevenir el daño oxidativo provocado por el calor. Feel the MAGIC of science on your skin!',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-image.jpg',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-image.jpg',
            desktop: '',
          },
        },
      },
      {
        blockType: 'BenefitsContent',
        props: {
          title: 'Ser isdinlover es disfrutar de beneficios únicos',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Desk.png',
            desktop: '',
          },
          benefits: [
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono01.png',
              description:
                'Disfruta de productos y experiencias <strong>únicas.</strong>',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono02.png',
              description:
                'Aprende a <strong>cuidar tu piel</strong> junto a los mejores expertos.',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono03.png',
              description:
                'Entérate de las últimas novedades <strong>¡antes que nadie!</strong>',
            },
          ],
        },
      },
    ],
  },
  [PlatformEnum.CON_ITALY]: {
    title: 'Alcaraz landing',
    availableDevices: [DeviceEnum.MOBILE, DeviceEnum.TABLET],
    blocks: [
      {
        blockType: 'VideoContent',
        props: {
          title: 'Ciao, isdinlover!',
          description:
            'Ti diamo il benvenuto in LOVE ISDIN, la community di chi ama la propria pelle in cui potrai vivere <strong>esperienze esclusive</strong>, anche insieme al nostro <strong>brand ambassador Carlos Alcaraz</strong>. Accedi a LOVE ISDIN e scopri come!',
          video: {
            mobile: {
              vertical: true,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/VIDEO_LANDING_ROLAND_GARROS_2.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              aspectRatio: ApectRatioEnum['4_5'],
            },
            tablet: {
              vertical: false,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/VIDEO_LANDING_ROLAND_GARROS_2.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
            },
            desktop: {
              vertical: false,
              url: '',
            },
          },
        },
      },
      {
        blockType: 'ConsumableContent',
        props: {
          type: ConsumableContentTypeEnum.CUSTOM,
          title: 'Vuoi vivere momenti magici con Alcaraz?',
          description: 'Divertiti dentro e fuori dal campo con il numero 1.',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-consumable-racket.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-consumable-racket.png',
            desktop: '',
          },
        },
      },
      {
        blockType: 'ImageContent',
        props: {
          title: 'Fusion Water MAGIC by Alcaraz',
          description:
            'Hai appena segnato un grande punto, perché <strong>proteggersi dal sole</strong> è il primo passo per vincere.<br>Con una texture ultraleggera e a rapido assorbimento, <strong>Fusion Water MAGIC by Alcaraz</strong> è un <strong>fotoprotettore viso resistente al sudore</strong> e formulato con <strong>Heat Stress Protect</strong>, un potente antiossidante che aiuta a prevenire i danni ossidativi causati dal calore. <strong>Vivi la MAGIA della scienza sulla tua pelle!</strong>',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-image.jpg',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-image.jpg',
            desktop: '',
          },
        },
      },
      {
        blockType: 'BenefitsContent',
        props: {
          title: 'Essere isdinlover significa godere di vantaggi unici',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Desk.png',
            desktop: '',
          },
          benefits: [
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono01.png',
              description:
                'Goditi prodotti ed esperienze <strong>uniche.</strong>',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono02.png',
              description:
                'Impara a <strong>prenderti cura della tua pelle</strong> con i migliori esperti.',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono03.png',
              description:
                'Scopri tutte le novità <strong>prima di chiunque altro!</strong>',
            },
          ],
        },
      },
    ],
  },
  [PlatformEnum.CON_FRANCE]: {
    title: 'Alcaraz landing',
    availableDevices: [DeviceEnum.MOBILE, DeviceEnum.TABLET],
    blocks: [
      {
        blockType: 'VideoContent',
        props: {
          title: 'Bonjour, isdinlover',
          description:
            'Bienvenue dans LOVE ISDIN, la communauté de ceux qui aiment prendre soin de leur peau et où vous vivrez des <strong>expériences exclusives autour du tennis avec notre ambassadeur Carlos Alcaraz</strong>. Rejoignez LOVE ISDIN et accédez à tous les privilèges qui vous sont réservés !',
          video: {
            mobile: {
              vertical: true,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/VIDEO_LANDING_ROLAND_GARROS_2.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              aspectRatio: ApectRatioEnum['4_5'],
            },
            tablet: {
              vertical: false,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/VIDEO_LANDING_ROLAND_GARROS_2.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
            },
            desktop: {
              vertical: false,
              url: '',
            },
          },
        },
      },
      {
        blockType: 'ConsumableContent',
        props: {
          type: ConsumableContentTypeEnum.CUSTOM,
          title: 'Souhaitez-vous vivre des moments magiques avec Alcaraz ?',
          description:
            'Savourez chaque instant, sur le court et en dehors, aux côtés du numéro 1.',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-consumable-racket.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-consumable-racket.png',
            desktop: '',
          },
        },
      },
      {
        blockType: 'ImageContent',
        props: {
          title: 'Fusion Water MAGIC by Alcaraz',
          description:
            'Vous venez de marquer un bon point, car <strong>vous protéger du soleil</strong> est la première étape pour gagner.<br>Avec sa texture ultra-légère et sa rapidité d’absorption, cette <strong>protection solaire extraordinaire est résistante à la transpiration</strong> et formulée avec <strong>Heat Stress Protect</strong>, un puissant antioxydant qui aide à prévenir les dommages oxydatifs causés par la chaleur. <strong>Ressentez la MAGIE de la science sur votre peau !</strong>',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-image.jpg',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-image.jpg',
            desktop: '',
          },
        },
      },
      {
        blockType: 'BenefitsContent',
        props: {
          title: 'Être un isdinlover, c’est profiter d’avantages uniques',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Desk.png',
            desktop: '',
          },
          benefits: [
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono01.png',
              description:
                'Profitez de produits et d’expériences <strong>uniques.</strong>',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono02.png',
              description:
                'Apprenez à <strong>prendre soin de votre peau</strong> avec les meilleurs experts.',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono03.png',
              description:
                'Soyez informé des dernières nouveautés <strong>avant tout le monde !</strong>',
            },
          ],
        },
      },
    ],
  },
  [PlatformEnum.CON_DEUTSCHLAND]: {
    title: 'Alcaraz landing',
    availableDevices: [DeviceEnum.MOBILE, DeviceEnum.TABLET],
    blocks: [
      {
        blockType: 'VideoContent',
        props: {
          title: 'Hallo, isdinlover',
          description:
            'Willkommen bei LOVE ISDIN, der Community der Hautliebhaber, wo du <strong>exklusive Tennis-Erlebnisse mit unserem Botschafter Carlos Alcaraz</strong> und vieles mehr erleben kannst. Greife auf LOVE ISDIN zu und entdecke wie!',
          video: {
            mobile: {
              vertical: true,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/VIDEO_LANDING_ROLAND_GARROS_2.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
              aspectRatio: ApectRatioEnum['4_5'],
            },
            tablet: {
              vertical: false,
              url: 'https://media.love.isdin.com/con-es/consumables/videos/VIDEO_LANDING_ROLAND_GARROS_2.mp4',
              poster:
                'https://media.love.isdin.com/con-es/consumables/images/LICON_CapturaVideo_Mobile.png',
            },
            desktop: {
              vertical: false,
              url: '',
            },
          },
        },
      },
      {
        blockType: 'ConsumableContent',
        props: {
          type: ConsumableContentTypeEnum.CUSTOM,
          title: 'Möchtest du magische Momente mit Alcaraz erleben?',
          description: 'Genieße es auf und neben dem Platz mit der Nummer 1.',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-consumable-racket.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-consumable-racket.png',
            desktop: '',
          },
        },
      },
      {
        blockType: 'ImageContent',
        props: {
          title: 'Fusion Water MAGIC by Alcaraz',
          description:
            'Du hast gerade einen guten Punkt gemacht, denn <strong>sich vor der Sonne zu schützen</strong> ist der erste Schritt zum Sieg.<br>Mit ultraleichter Textur und schneller Absorption ist dieser <strong>außergewöhnliche Sonnenschutz resistent gegen Schweiß</strong> und wurde mit <strong>Heat Stress Protect</strong> formuliert, einem starken Antioxidans, das hilft, oxidativen Schaden durch Hitze zu verhindern. <strong>Spüre die MAGIE der Wissenschaft auf deiner Haut!</strong>',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-image.jpg',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/isdin-fw-alcaraz-rg-image.jpg',
            desktop: '',
          },
        },
      },
      {
        blockType: 'BenefitsContent',
        props: {
          title:
            'Isdinlover zu sein bedeutet, einzigartige Vorteile zu genießen',
          image: {
            mobile:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Mob.png',
            tablet:
              'https://media.love.isdin.com/con-es/consumables/images/ALCARAZ_IMG_Community_LICON_Desk.png',
            desktop: '',
          },
          benefits: [
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono01.png',
              description:
                'Genieße <strong>einzigartige Produkte und Erlebnisse.</strong>',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono02.png',
              description:
                'Lerne, <strong>deine Haut zu pflegen</strong> – gemeinsam mit den besten Experten.',
            },
            {
              icon: 'https://media.love.isdin.com/con-es/consumables/images/licon_benefits_Icono03.png',
              description:
                'Erfahre Neuigkeiten <strong>noch bevor alle anderen!</strong>',
            },
          ],
        },
      },
    ],
  },
});
